import { Address } from '../../../../model/Address'
import { SelectOption } from '../../../../model/SelectOption'
import { addError} from '../../../../store/message'

export interface PatientContactsFormBlockProps {
  addError: typeof addError
  colorPreset?: 'light' | 'dark'
  patientAddress?: Address | null
  patientId?: number
}

export const CONTACT_VISIBILITY_OPTIONS: SelectOption<boolean | null>[] = [
  { value: null, label: 'Tous' },
  { value: false, label: 'Publics' },
  { value: true, label: 'Privés' },
]
